// extracted by mini-css-extract-plugin
module.exports = {"searchNameBox":"_34sUeptv","editUiContent":"_3Y3NJ4_d","wrapper":"_3ccJbh9s"};